import { type ReactNode } from 'react';
import { Information } from '@hungryroot/icons';
import { Text } from '@hungryroot/ramen';
import { useGetCustomerProductSubscriptionConfig } from './useGetCustomerProductSubscriptionConfig';
import utilityStyles from '../utils/utilityStyles.module.css';

export function useProductSubscriptionCancelWarningExperimentApi():
  | ReactNode
  | undefined {
  const { data: customerProductSubscription } =
    useGetCustomerProductSubscriptionConfig();

  if (customerProductSubscription === undefined) {
    return undefined;
  }

  return (
    <div
      data-testid="subscription-cancel-warning"
      className={utilityStyles['cancel-text']}
    >
      <Information />
      <Text>Monthly supplement deliveries</Text>
    </div>
  );
}
